export default __webpack_public_path__ + "static/media/pro-7.27a832ad.jpg";